import { RentList } from '../components/elements/warehouse_rent_list_app/warehouse_rent_list/warehouse_rent_list_types'

const LOAD_DATA = 'warehouse_rent_list/LOAD_DATA'
const RENT_ELEMENT = 'warehouse_rent_list/RENT_ELEMENT'
const RENT_ELEMENT_REQUEST = `${RENT_ELEMENT}_REQUEST`
const RENT_ELEMENT_FAILURE = `${RENT_ELEMENT}_FAILURE`
const CLEAR_ERRORS = 'warehouse_rent_list/CLEAR_ERRORS'

export const types = {
  LOAD_DATA,
  RENT_ELEMENT,
  RENT_ELEMENT_REQUEST,
  RENT_ELEMENT_FAILURE,
  CLEAR_ERRORS,
}

export const loadData = (data: RentList) => ({
  type: LOAD_DATA,
  data,
})

export const rentElement = (rentListId: number, elementId: number, warehouseId: number, quantity: number = 1) => ({
  type: RENT_ELEMENT,
  request: {
    url: `/warehouses/${warehouseId}/warehouse_rent_lists/${rentListId}/rent_element.json`,
    method: 'post',
    body: {
      element_id: elementId,
      quantity: quantity,
    },
  },
})

export const clearErrors = () => ({
  type: CLEAR_ERRORS,
})
